import { render, staticRenderFns } from "./Layouts.vue?vue&type=template&id=07981dba"
import script from "./Layouts.vue?vue&type=script&lang=ts"
export * from "./Layouts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports